import React from "react";

export default class PageHeader extends React.Component {
  renderTitle() {
    return (
      <div className="page-header d-flex align-items-end pb-4 bg-blue">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-8 col-lg-7">
              <h1 className="text-uppercase" style={{ color: "#fff" }}>
                {this.props.title}
              </h1>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return <div>{this.props.title ? this.renderTitle() : null}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/PageHeader.js